/** @format */

import React, { Component } from 'react';
// import {FormGeneralHelper} from "../../helpers/FormGeneral";
import PropTypes from 'prop-types';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import Check from '@material-ui/icons/Check';
import CheckBox from '@material-ui/core/Checkbox';

import withStyles from '@material-ui/core/styles/withStyles';
import adescomStyle from 'assets/jss/adescom/adescomStyle';
import I18n from '../../components/Translate/I18n';

class CheckBoxFormRest extends Component {
    render() {
        const { classes, checked, label, id, callback, stateName } = this.props;
        return (
            <FormControlLabel
                control={
                    <CheckBox
                        id={id ? id : 'isPrivateClient'}
                        tabIndex="-1"
                        checkedIcon={<Check className={classes.checkedIcon} />}
                        icon={<Check className={classes.uncheckedIcon} />}
                        classes={{
                            checked: classes.checked,
                            root: classes.checkRoot,
                        }}
                        onClick={(e) => {
                            if (callback) {
                                callback(e.target.checked, stateName);
                            }
                        }}
                        checked={checked}
                    />
                }
                classes={{ label: classes.label }}
                label={<I18n trans={label} />}
            />
        );
    }
}

CheckBoxFormRest.propTypes = {
    classes: PropTypes.object.isRequired,
    checked: PropTypes.bool,
    label: PropTypes.string.isRequired,
    callback: PropTypes.func,
    id: PropTypes.string,
    stateName: PropTypes.string,
};

export default withStyles(adescomStyle)(CheckBoxFormRest);
